const CustomAd = (api: any) => ({
  createCustomAd: (adContent: any) => api.post('/api/v1/custom-ad/', {}, adContent),
  getCustomAds: () => api.get(`/api/v1/custom-ad/`, {}, {}),
  updateCustomAd: (customAdId: number, adContent: any) =>
    api.put(`/api/v1/custom-ad/${customAdId}`, {}, adContent),
});

export default CustomAd;
